<template>
  <section
    :style="data.style ? data.style : isDark ? 'secondary' : ''"
    :class="`${isDark ? 'secondary white--text' : ''} ${data.class}`"
    id="header"
  >
    <v-container class="header">
      <v-row align="center" justify="center">
        <v-col cols="12" lg="5" xl="5" class="text-center">
          <img src="/vp_sm.png" style="width: 100%; height: auto" />
        </v-col>
        <v-col
          cols="12"
          sm="11"
          md="10"
          lg="7"
          xl="4"
          style="padding-top: 50px"
        >
          <h2 class="page-heading">{{ data.title }}</h2>
          <p v-html="data.description"></p>

          <v-row class="header-tiles" v-if="data.tiles">
            <v-col
              cols="12"
              sm="6"
              md="4"
              lg="4"
              xl="4"
              v-for="(tile, t) in data.tiles"
              :key="t"
            >
              <h4 class="page-heading">{{ tile.title }}</h4>

              <p
                class="tile-description small-text"
                v-html="tile.description"
              ></p>
              <div class="small-text" v-if="tile.link">
                <span v-if="tile.link.url">
                  <a
                    target="_blank"
                    v-if="tile.link.url.startsWith('http')"
                    :href="tile.link.url"
                    >{{ tile.link.text }}</a
                  >
                  <router-link v-else :to="tile.link.url">{{
                    tile.link.text
                  }}</router-link>
                </span>
                <span
                  v-else-if="tile.link.video"
                  class="clicky primary--text"
                  @click="$eventBus.$emit('play_video', tile.link.video)"
                  >{{ tile.link.text }}</span
                >
              </div>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </section>
</template>

<script>
export default {
  name: "PageHeader",
  props: ["value"],
  data() {
    return {};
  },
  computed: {
    data() {
      return this.value;
    },
    isDark() {
      return this.value.dark ? true : false;
    },
  },
};
</script>

<style lang="scss">
.small-text {
  font-size: 12px;
}
.header a {
  text-decoration: none !important;
}
.tile-description {
  min-height: auto;
  @media only screen and (min-width: 992px) {
    min-height: 100px;
  }
}
.header {
  padding-top: 100px;
  padding-bottom: 100px;
  /* Extra small devices (phones, 600px and down) */
  @media only screen and (max-width: 600px) {
    padding-top: 20px;
    padding-bottom: 20px;
  }

  /* Small devices (portrait tablets and large phones, 600px and up) */
  @media only screen and (min-width: 600px) {
    padding-top: 30px;
    padding-bottom: 30px;
  }

  /* Medium devices (landscape tablets, 768px and up) */
  @media only screen and (min-width: 768px) {
    padding-top: 40px;
    padding-bottom: 40px;
  }

  /* Large devices (laptops/desktops, 992px and up) */
  @media only screen and (min-width: 992px) {
    padding-top: 50px;
    padding-bottom: 50px;
  }

  /* Extra large devices (large laptops and desktops, 1200px and up) */
  @media only screen and (min-width: 1200px) {
    padding-top: 80px;
    padding-bottom: 80px;
  }
}
.header-tiles {
  margin-top: 20px;
  margin-bottom: 20px;
  @media only screen and (max-width: 959px) {
    padding-top: 0px;
  }
  @media only screen and (max-width: 375px) {
    padding-top: 0px;
  }
}
.logofont {
  font-family: "Arial Rounded MT Bold", sans-serif;
  font-size: 80px;
  letter-spacing: -0.05em;
  /* Extra small devices (phones, 600px and down) */
  @media only screen and (max-width: 600px) {
    font-size: 70px;
  }

  /* Small devices (portrait tablets and large phones, 600px and up) */
  @media only screen and (min-width: 600px) {
    font-size: 90px;
  }

  /* Medium devices (landscape tablets, 768px and up) */
  @media only screen and (min-width: 768px) {
    font-size: 110px;
  }

  /* Large devices (laptops/desktops, 992px and up) */
  @media only screen and (min-width: 992px) {
    font-size: 120px;
  }

  /* Extra large devices (large laptops and desktops, 1200px and up) */
  @media only screen and (min-width: 1200px) {
    font-size: 80px;
  }
}
</style>